
import Vue from "vue";
import QuestionFile from "components/AliyunOSS/QuestionFile.vue";
export default Vue.extend({
  name: "EnclosureQuestion",
  components: {
    QuestionFile
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },
    /* --------------------------跳转页面参数----------------------------- */
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    }
    // faceTeachState: {
    //   type: String,
    //   default: ""
    // },
    /* ------------------------------------------------------------------- */
  },
  data() {
    return {
      content: {},
      fileList: [],
      title: "",
      desceiption: "",
        urlAliyunOSS: '/api/design/osssign/getsign',
      fileIds: [], // 附件Id
      filesList: [],
      IsShowFile: true,
      // 是否展示富文本框
      isShowEditor: true,
      isShowInput: false,
      // 总分
      totalScore: 0,
      Score: 0,
      isTotalScore: false
    };
  },
  watch: {},
  created() {
    this.getEnclosureQuestion();
  },
  methods: {
    // 返回上级
    goback: function() {
      this.$router.go(-1);
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    getEnclosureQuestion: function() {
      this.$http.post('/api/XOrg/BookMaterial/geEnclosureInfoById',{
        paperId: this.paperId
      }).then(rst => {
        this.title = rst.info.Title;
        this.desceiption = rst.info.Descriptioin;
        this.filesList = rst.info.FileList;
        this.totalScore = rst.info.TotalScore;
        this.Score = rst.info.TotalScore;
      });
    },
    addEnclosureQuestion: function() {
      this.$http.post('/api/XOrg/BookMaterial/editEnclosurePaperById',{
        paperId: this.paperId, 
        title: this.title, 
        desceiption: this.desceiption, 
        fileIds: this.fileIds
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
          // this.$router.push({
          //   name: "Paper",
          //   params: {
          //     courseId: this.courseId
          //   }
          // });
           this.$router.go(-1);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    goto: function(name, params) {
      if (this.paperType === "lectures") {
        this.$router.push({
          name: this.paperType,
          params: {
            courseId: this.courseId,
            classId: this.classId,
            faceId: this.faceId
            // faceTeachState:this.faceTeachState
          }
        });
      } else {
        this.$router.push({ name: this.paperType, params: params });
      }
    },
    Preview: function(data) {
      this.isShowEditor = !data;
    },
    shuxin: function(data) {
      //debugger;
      this.IsShowFile = false;
      this.IsShowFile = true;
    },
    showTitleInput: function() {
      this.isShowInput = true;
    },
    hideTitleInput: function() {
      this.isShowInput = false;
      this.updatePaperName();
    },
    updatePaperName: function() {
      this.$http.post('/api/XOrg/BookMaterial/updatePaperName',{
        paperId: this.paperId, 
        paperName: this.title, 
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    updatePaperScore: function() {
      this.$http.post('/api/XOrg/BookMaterial/updatePaperScore',{
        paperId: this.paperId,
        totalScore: this.totalScore
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    showTotalScore: function() {
      this.isTotalScore = true;
    },
    hideScoreInput: function() {
      this.isTotalScore = false;
      if (this.totalScore < 0 || this.totalScore > 1000) {
        this.totalScore = this.Score;
        this.$message.warning("总分必须在0~1000之间");
      } else {
        this.updatePaperScore();
      }
    }
  }
});
